@defer (when vm) {
  <div class="sidenav-item" [ngClass]="{ 'locked': item.isLocked }">
    <a mat-list-item [ngClass]="{ active: vm.isActive() }" (click)="onItemSelected()">
      <span class="route-icon"><i class="fa {{ item.iconClass }}"></i></span>
      <span class="route-text">{{ item.displayName | translate }}</span>
    </a>
    <!-- Lock indicator for locked items -->
    <span class="lock-indicator" *ngIf="item.isLocked" [attr.title]="'SIDEMENU.UPGRADE_REQUIRED' | translate">
      <i class="fa-solid fa-lock lock-icon"></i>
      <span class="tier-badge">{{ 'SIDEMENU.UPGRADE' | translate }}</span>
    </span>
    <!-- Favorite star (outside <a> to avoid navigation) - hidden for locked items -->
    <span class="favorite-star"
          *ngIf="!item.isLocked && !isMyDashboard && !isInFavorites"
          (click)="onToggleFavorite($event)"
          [ngClass]="{
            'is-favorite': isFavorite(),
            'is-loading': isTogglingFavorite()
          }"
          [attr.title]="isFavorite() ? ('SIDEMENU.REMOVE_FROM_FAVORITES' | translate) : ('SIDEMENU.ADD_TO_FAVORITES' | translate)">
      <!-- Spinner while saving -->
      <i *ngIf="isTogglingFavorite()" class="fas fa-spinner fa-spin"></i>
      <!-- Normal star -->
      <i *ngIf="!isTogglingFavorite()" class="fa-star" [ngClass]="isFavorite() ? 'fas' : 'far'"></i>
    </span>
  </div>
}
